import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { Text } from "@examspark/common-ui";

const Styled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`;

const StyledTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Title = styled(Text.H1)`
  flex: 1;
`;
const Subtitle = styled(Text.H2)`
  flex: 1;
  font-size: 1.4rem;
`;
const Tools = styled.div`
  margin-left: auto;
`;

const PageTitle = (
  props: PropsWithChildren<{
    tools?: React.ReactNode;
    subtitle?: React.ReactNode;
  }>,
) => {
  return (
    <Styled>
      <StyledTitleWrapper>
        <Title>{props.children}</Title>
        {props.subtitle != null && <Subtitle>{props.subtitle}</Subtitle>}
      </StyledTitleWrapper>
      {props.tools != null && <Tools>{props.tools}</Tools>}
    </Styled>
  );
};

export default PageTitle;
